import React, { useEffect, useState, useCallback } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import {
  Container, Message, Card, Label, Divider, Icon, Image,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import api from 'api';
import util from 'utils/utils';

import { Other } from 'simplydo/interfaces';
import { UserChip } from 'components/lib/Chips';
import IdeaBody from './Body';

interface MatchParams {
  id: string;
}

interface IdeaPdfProps extends RouteComponentProps<MatchParams> {
  t: any,
}

const IdeaPDF = ({ t, match }: IdeaPdfProps) => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [idea, setIdea] = useState<Other.IIdea | null>(null);
  const matchId = match.params.id;

  const getIdea = useCallback(() => {
    setErrorMessage('');
    api.ideas.get(matchId, (ideaData: Other.IIdea) => setIdea(ideaData), (err) => setErrorMessage(err.message), null);
  }, [matchId]);

  useEffect(() => {
    getIdea();
  }, [matchId, getIdea]);

  if (errorMessage) return (<Message><p><strong>{t('ideas.pdf.problem')} </strong></p ><p>{errorMessage} </p></Message >);
  if (!idea) return null;
  return (
    <div style={{ background: 'white', paddingTop: 40 }
    }>
      <Container className='idea' >
        <Card.Group centered >
          <Card raised >
            <Image src={util.ideaCoverImage(idea)} />
            <Card.Content >
              <Card.Header>{idea.name} </Card.Header>
              {
                idea.ownerChallenge
                && <Card.Meta>{idea.isPinned && <Label size='tiny' color='olive' > <Icon name='thumbtack' /> {t('ideas.tags.pinned')}</Label >} In < Link to={`/challenges/${idea.ownerChallenge._id}`
                }> {idea.ownerChallenge?.name} </Link></Card.Meta >
              }
            </Card.Content>
          </Card>

          <Card raised >
            <Card.Content>
              <div style={{ marginTop: '5px' }} />
              {idea.conceptKeywords && idea.conceptKeywords.map((keyword, i) => <Label key={i} tag size='small' style={{ marginBottom: '5px' }}> {keyword} </Label>)}
              <div style={{ marginTop: 10 }} />
              {idea.authors && idea.authors.map((author) => <UserChip key={author._id}
                // @ts-ignore
                user={author} style={{ marginRight: 10, marginBottom: 10, display: 'inline-block' }} />)}
            </Card.Content>
            <Card.Content extra textAlign='right' >
              {t('ideas.pdf.updated', { date: moment(idea.updatedAt).format('MMMM Do, YYYY') })}
            </Card.Content>
          </Card>
        </Card.Group>
        < Divider section hidden />
        < Divider section hidden />
        <div>
          {/* @ts-ignore */}
          <IdeaBody
            idea={idea}
            isPDF
          />
        </div>
      </Container>
    </div>
  );
};

export default withTranslation()(IdeaPDF);
